<template>
  <div>
    <a-form-model class="basic" :model="form" :rules="rules" ref="baseForm">
      <a-collapse
        :bordered="true"
        expand-icon-position="right"
        :activeKey="[
          '1',
          '2',
          '3',
          '4',
          '5',
          '6',
          '7',
          '8',
          '9',
          '10',
          '11',
          '12',
        ]"
        class="detail-collapse"
      >
        <!-- ===================== 项目基本信息 ===================== -->
        <a-collapse-panel key="1">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">
                项目基本信息
              </div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <BasicInfo :form="form" :isEditable="isEditable"></BasicInfo>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 权证信息 ===================== -->
        <a-collapse-panel key="2">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">权证信息</div>
            </a-space>
          </template>
          <RightInfo
            :selectHouseList="selectHouseList"
            ref="rightInfo"
          ></RightInfo>
        </a-collapse-panel>

        <!-- ===================== 房源属性信息 ===================== -->
        <a-collapse-panel key="3">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">房源信息</div>
            </a-space>
          </template>
          <ResourceInfo
            :selectHouseList="selectHouseList"
            :intentWebId="webId"
            :form="form"
            :isEditable="isEditable"
          ></ResourceInfo>
        </a-collapse-panel>

        <!-- ===================== 招租信息 ===================== -->
        <a-collapse-panel key="4">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">招租信息</div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <RentalInfo :form="form" :isEditable="isEditable"></RentalInfo>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 承租资格条件 ===================== -->
        <a-collapse-panel key="5">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">
                承租资格条件
              </div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <Prerequisites
              :form="form"
              :isEditable="isEditable"
            ></Prerequisites>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 联系方式 ===================== -->
        <a-collapse-panel key="6">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">联系方式</div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <ContactWay :form="form" :isEditable="isEditable"></ContactWay>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 公告时间 ===================== -->
        <a-collapse-panel key="7">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">公告时间</div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <AnnouncementTime
              :form="form"
              :isEditable="isEditable"
            ></AnnouncementTime>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 出租方信息 ===================== -->
        <a-collapse-panel key="8">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">出租方信息</div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <LessorInfo :form="form" :isEditable="isEditable" :registerAddressString="registerAddressString"></LessorInfo>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 房源封面 ===================== -->
        <a-collapse-panel key="9">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">房源封面</div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <HousingCover :form="form" :isEditable="isEditable"></HousingCover>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 房源图片 ===================== -->
        <a-collapse-panel key="10">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">房源图片</div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <HousingPicture
              :form="form"
              :isEditable="isEditable"
            ></HousingPicture>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 其他公示的附件（对外公示） ===================== -->
        <a-collapse-panel key="11">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">
                其他公示的附件（对外公示）
              </div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <FileAttachment
              :attachmentList="form.publicAttachment"
              :isEditable="isEditable"
            ></FileAttachment>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 材料补充清单 ===================== -->
        <a-collapse-panel key="12">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div
                class="ant-descriptions-title"
                style="font-size: 16px; margin-bottom: 0px"
              >
                材料补充清单
              </div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <SupplyCheck :form="form" :isEditable="isEditable"></SupplyCheck>
          </a-spin>
        </a-collapse-panel>
      </a-collapse>
    </a-form-model>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import BasicInfo from "./basicInfo/BasicInfo";
import RightInfo from "./rightInfo/RightInfo";
import ResourceInfo from "./resourceInfo/ResourceInfo";
import RentalInfo from "./rentalInfo/RentalInfo";
import Prerequisites from "./prerequisites/Prerequisites";
import ContactWay from "./contactWay/ContactWay";
import AnnouncementTime from "./announcementTime/AnnouncementTime";
import LessorInfo from "./lessorInfo/LessorInfo";
import HousingCover from "./housingCover/HousingCover";
import HousingPicture from "./housingPicture/HousingPicture";
import FileAttachment from "./attachment/FileAttachment";
import SupplyCheck from "./supplyCheck/SupplyCheck";
import { getObligeeDetail } from "@/api/company/Company.js";
import {
  saveIntentLease,
  submitIntentLease,
  getIntentDetail,
} from "@/api/project/Project.js";
export default {
  props: {
    isEditable: {
      type: Boolean,
      default: () => true,
    },
    isRepublish: {
      type: Boolean,
      default: () => true,
    },
    webId: {
      type: String,
      default: () => undefined,
    },
    selectHouseList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    BasicInfo,
    RightInfo,
    ResourceInfo,
    RentalInfo,
    Prerequisites,
    ContactWay,
    AnnouncementTime,
    LessorInfo,
    HousingCover,
    HousingPicture,
    FileAttachment,
    SupplyCheck,
  },
  computed: {
    startingPrice() {
      return Number(this.form.floorPrice) || 0;
    },
  },
  data() {
    return {
      spinning: false,
      form: {
        //父层传值
        otype: 0,
        webId: undefined,
        //存库
        houseResourceIds: this.selectHouseList,
        //项目基本信息
        projectId: "",
        projectName: "",
        rentWay: 2,
        stateOwned: 1,
        onlineSignup: 1,
        //地图相关
        longitude: undefined,
        dimension: undefined,
        //招租信息
        leaseTermType: 1,
        leaseTermMin: undefined,
        leaseTermMax: undefined,

        leaseTerm: undefined,
        leaseTermUnit: 1,
        listingPriceType: 1,
        listingPrice: undefined,
        listingPriceDown: undefined,
        listingPriceUp: undefined,
        listingPriceUnit: 2,
        rentCount: undefined,
        acceptSplitRent: undefined,
        splitRentDesc: undefined,
        engineeringConditions: [],
        leaseType: [],
        leaseUseType: [],
        leaseUseDesc: undefined,
        businessCategories: [],
        parkCategories: [],
        decorateStatus: undefined,
        allowRemodeling: 0,
        remodelingDesc: undefined,
        projectDesc: undefined,
        formatRequirements: undefined,
        parkingSpaceAvailable: 0,
        numberParkingSpaces: undefined,
        policyRecommendations: undefined,
        hasRentAdjustments: 0,
        rentAdjustmentWay: undefined,
        hasRentFreePeriod: 2,
        hasRentFreePeriodType: undefined,
        rentFreePeriod: undefined,
        rentFreePeriodMin: undefined,
        rentFreePeriodMax: undefined,
        rentFreePeriodUnit: 2,
        isRfpEtLr: 0,
        hasRentContainFreePeriod: 0,
        hasPropertyManagementFee: 0,
        propertyManagementFee: undefined,
        propertyManagementFeeUnit: 1,
        sublease: 0,
        subleaseDesc: undefined,
        rentPaymenclaim: 1,
        rentPaymenclaimDeposit: undefined,
        rentPaymenclaimPay: undefined,
        rentPaymenclaimOtherDesc: undefined,
        otherDesc: undefined,
        //承租资格条件
        intentionLeaseRange: [],
        qualificationCondition:
          "1.意向承租方应具有良好的财务状况和支付能力；\n2.意向承租方应具有良好商业信用，无不良经营记录；\n3.符合国家法律、行政法规规定的其他条件。",
        supportingServices: [],
        //联系方式
        lessorContact: undefined,
        lessorContactPhone: undefined,
        lessorContact2: undefined,
        lessorContactPhone2: undefined,
        //公告时间
        disclosureMethod: 1,
        disclosurePeriod: 5,
        disclosurePeriodExtend: 14,
        extendWorkingDays: undefined,
        extendedCyclesNumber: undefined,
        //出租方信息
        hasEntrustRent: 1,
        lessorName: "",
        lessorType: 1,
        certType: 19,
        certNumber: "",
        legalPerson: "",
        registAddress: "",
        hasLessorStateOwned: 1,
        economicTypeLessor: undefined,
        groupDepartment: undefined,
        regulatoryAuthorities: undefined,
        personCertType: 0,
        personCertNumber: undefined,
        country: undefined,
        provinceCityRegion: undefined,
        coverPhoto: [],
        projectPhoto: [],
        //其他公示的附件
        publicAttachment: [
          {
            id: 1,
            type: "其他公示的附件",
            files: [],
            uploadType: 301,
          },
        ],
        //材料补充清单
        supplyCheckList: [],
      },
      //用于后端返回值
      registerAddressString: undefined,
      rules: {
        projectName: [{ required: true, message: "请输入项目名称" }],
        rentWay: [{ required: true, message: "请选择出租方式" }],
        stateOwned: [{ required: true, message: "请选择是否为国资" }],
        onlineSignup: [{ required: true, message: "请选择是否在线报名" }],
        leaseTermType: [{ required: true, message: "请选择租赁期限类型" }],
        leaseTermMin: [
          {
            validator: (rule, value, callback) => {
              const max = this.form.leaseTermMax;

              if (value === "" || value === null || value === undefined) {
                return callback("请输入租赁期限下区间");
              }

              if (isNaN(value)) {
                return callback("请输入数字");
              }

              if (Number(value) <= 0) {
                return callback("租赁期限下区间必须大于0");
              }

              if (
                max !== "" &&
                max !== null &&
                max !== undefined &&
                !isNaN(max) &&
                Number(value) > Number(max)
              ) {
                return callback("租赁期限下区间不得大于上区间");
              }

              callback();
            },
            trigger: ["blur", "change"],
          },
        ],
        leaseTermMax: [
          {
            validator: (rule, value, callback) => {
              const min = this.form.leaseTermMin;

              if (value === "" || value === null || value === undefined) {
                return callback("请输入租赁期限上区间");
              }

              if (isNaN(value)) {
                return callback("请输入数字");
              }

              if (Number(value) <= 0) {
                return callback("租赁期限上区间必须大于0");
              }

              if (
                min !== "" &&
                min !== null &&
                min !== undefined &&
                !isNaN(min) &&
                Number(value) < Number(min)
              ) {
                return callback("租赁期限上区间不得小于下区间");
              }

              callback();
            },
            trigger: ["blur", "change"],
          },
        ],
        leaseTerm: [
          { required: true, message: "请输入租赁期限", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (value === "" || value === null || value === undefined) {
                return callback("请输入租赁期限");
              }

              if (isNaN(value)) {
                return callback("请输入数字");
              }

              if (Number(value) <= 0) {
                return callback("租赁期限必须大于0");
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        listingPriceType: [{ required: true, message: "请选择出租参考价类型" }],
        listingPrice: [
          { required: true, message: "请输入出租参考价价格", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (value === "" || value === null || value === undefined) {
                return callback("请输入出租参考价价格");
              }

              if (isNaN(value)) {
                return callback("请输入数字");
              }

              if (Number(value) <= 0) {
                return callback("出租参考价价格必须大于0");
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        listingPriceDown: [
          {
            validator: (rule, value, callback) => {
              const max = this.form.listingPriceUp;

              if (this.form.listingPriceType !== 2) {
                return callback();
              }

              if (value === "" || value === null || value === undefined) {
                return callback("请输入出租参考价下区间");
              }

              if (isNaN(value)) {
                return callback("请输入数字");
              }

              if (Number(value) <= 0) {
                return callback("出租参考价下区间必须大于0");
              }

              if (
                max !== "" &&
                max !== null &&
                max !== undefined &&
                !isNaN(max) &&
                Number(value) > Number(max)
              ) {
                return callback("出租参考价下区间不得大于上区间");
              }

              callback();
            },
            trigger: ["blur", "change"],
          },
        ],

        listingPriceUp: [
          {
            validator: (rule, value, callback) => {
              const min = this.form.listingPriceDown;

              if (this.form.listingPriceType !== 2) {
                return callback();
              }

              if (value === "" || value === null || value === undefined) {
                return callback("请输入出租参考价上区间");
              }

              if (isNaN(value)) {
                return callback("请输入数字");
              }

              if (Number(value) <= 0) {
                return callback("出租参考价上区间必须大于0");
              }

              if (
                min !== "" &&
                min !== null &&
                min !== undefined &&
                !isNaN(min) &&
                Number(value) < Number(min)
              ) {
                return callback("出租参考价上区间不得小于下区间");
              }

              callback();
            },
            trigger: ["blur", "change"],
          },
        ],
        listingPriceUnit: [{ required: true, message: "请选择出租参考价单位" }],
        acceptSplitRent: [
          { required: true, message: "请选择是否接受分割出租" },
        ],
        splitRentDesc: [{ required: true, message: "请输入分割出租说明" }],
        leaseType: [{ required: true, message: "请选择租赁类型" }],
        leaseUseType: [{ required: true, message: "请选择项目业态" }],
        leaseUseDesc: [{ required: true, message: "请输入项目业态其他说明" }],
        businessCategories: [{ required: true, message: "请选择商业细分业态" }],
        parkCategories: [{ required: true, message: "请选择园区细分业态" }],
        decorateStatus: [{ required: true, message: "请选择装修现状" }],
        allowRemodeling: [{ required: true, message: "请选是否允许装修改造" }],
        remodelingDesc: [{ required: true, message: "请输入装修改造说明" }],
        projectDesc: [{ required: true, message: "请输入项目描述" }],
        formatRequirements: [{ required: true, message: "请输入业态要求" }],
        parkingSpaceAvailable: [
          { required: true, message: "请选择是否有停车位" },
        ],
        numberParkingSpaces: [
          { required: true, message: "请输入停车位个数", trigger: "blur" },
        ],
        hasRentAdjustments: [
          { required: true, message: "请选择是否涉及租金调整" },
        ],
        rentAdjustmentWay: [{ required: true, message: "请输入租金调整方式" }],
        hasRentFreePeriod: [{ required: true, message: "请选择是否有免租期" }],
        hasRentFreePeriodType: [
          { required: true, message: "请选择免租期类型" },
        ],
        rentFreePeriod: [{ required: true, message: "请输入免租期时间" }],
        rentFreePeriodMin: [
          {
            validator: (rule, value, callback) => {
              const max = this.form.rentFreePeriodMax;

              if (
                this.form.hasRentFreePeriod !== 1 ||
                this.form.hasRentFreePeriodType !== 2
              ) {
                return callback();
              }

              if (value === "" || value === null || value === undefined) {
                return callback("请输入免租期时间最小值");
              }

              if (isNaN(value)) {
                return callback("请输入数字");
              }

              if (Number(value) <= 0) {
                return callback("免租期时间最小值必须大于0");
              }

              if (
                max !== "" &&
                max !== null &&
                max !== undefined &&
                !isNaN(max) &&
                Number(value) > Number(max)
              ) {
                return callback("免租期时间最小值不得大于最大值");
              }

              callback();
            },
            trigger: ["blur", "change"],
          },
        ],

        rentFreePeriodMax: [
          {
            validator: (rule, value, callback) => {
              const min = this.form.rentFreePeriodMin;

              if (
                this.form.hasRentFreePeriod !== 1 ||
                this.form.hasRentFreePeriodType !== 2
              ) {
                return callback();
              }

              if (value === "" || value === null || value === undefined) {
                return callback("请输入免租期时间最大值");
              }

              if (isNaN(value)) {
                return callback("请输入数字");
              }

              if (Number(value) <= 0) {
                return callback("免租期时间最大值必须大于0");
              }

              if (
                min !== "" &&
                min !== null &&
                min !== undefined &&
                !isNaN(min) &&
                Number(value) < Number(min)
              ) {
                return callback("免租期时间最大值不得小于最小值");
              }

              callback();
            },
            trigger: ["blur", "change"],
          },
        ],
        rentFreePeriodUnit: [
          { required: true, message: "请选择免租期时间单位" },
        ],
        isRfpEtLr: [
          { required: true, message: "请选择原租户续租是否享有免租期" },
        ],
        hasRentContainFreePeriod: [
          { required: true, message: "请选择租赁期限是否含免租期" },
        ],
        hasPropertyManagementFee: [
          { required: true, message: "请选择是否有物业管理费" },
        ],
        propertyManagementFee: [
          {
            required: true,
            message: "请输入物业管理费金额",
            trigger: "blur",
          },
          {
            validator(rule, value, callback) {
              if (value === "" || value === null || value === undefined) {
                return callback("请输入物业管理费金额");
              }

              if (isNaN(value)) {
                return callback("请输入数字");
              }

              if (Number(value) <= 0) {
                return callback("物业管理费金额必须大于0");
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        propertyManagementFeeUnit: [
          { required: true, message: "请选择租赁物业管理费单位" },
        ],
        sublease: [{ required: true, message: "请选择是否可转租" }],
        subleaseDesc: [{ required: true, message: "请输入转租说明" }],
        rentPaymenclaimDeposit: {
          validator: (rule, value, callback) => {
            if (this.form.rentPaymenclaim === 1) {
              if (!value) {
                return callback("请输入支付要求");
              }
            }
            callback(); // 其他情况直接通过
          },
          trigger: "blur",
        },
        rentPaymenclaimPay: {
          validator: (rule, value, callback) => {
            if (this.form.rentPaymenclaim === 1) {
              if (!value) {
                return callback("请输入支付要求");
              }
            }
            callback();
          },
          trigger: "blur",
        },
        rentPaymenclaimOtherDesc: {
          validator: (rule, value, callback) => {
            if (this.form.rentPaymenclaim === 2) {
              if (!value) {
                return callback("请输入其他支付要求");
              }
            }
            callback(); // 其他情况直接通过
          },
          trigger: "blur",
        },
        //承租资格条件
        intentionLeaseRange: [
          { required: true, message: "请选择意向承租方范围" },
        ],
        qualificationCondition: [
          { required: true, message: "请输入潜在承租方应具备的资格条件" },
        ],
        //联系人
        lessorContact: [{ required: true, message: "请输入出租方联系人" }],
        lessorContactPhone: [
          { required: true, message: "请输入出租方联系电话" },
        ],
        //公告时间
        extendWorkingDays: [
          {
            validator: (rule, value, callback) => {
              if (this.form.disclosurePeriodExtend === 12) {
                if (!value) {
                  return callback("请输入延长工作日");
                }
              }
              callback(); // 其他情况直接通过
            },
            trigger: "blur",
          },
        ],
        extendedCyclesNumber: [
          {
            validator: (rule, value, callback) => {
              if (this.form.disclosurePeriodExtend === 12) {
                if (!value) {
                  return callback("请输入延长周期数");
                }
              }
              callback(); // 其他情况直接通过
            },
            trigger: "blur",
          },
        ],
        hasEntrustRent: [
          { required: true, message: "请选择是否受委托进行招租" },
        ],
        lessorName: [{ required: true, message: "请输入出租方名称" }],
        lessorType: [{ required: true, message: "请选择出租方类型" }],
        businessPrincipal: [{ required: true, message: "请输入出租方联系人" }],
        principalContactNumber: [
          { required: true, message: "请输入出租方联系人电话" },
        ],
        certType: [{ required: true, message: "请选择出租方证件类别" }],
        certNumber: [{ required: true, message: "请输入出租方证件号码" }],
        legalPerson: [{ required: true, message: "请输入出租方法定代表人" }],
        country: [{ required: true, message: "请选择国家" }],
        registerProvince: [
          { required: true, message: "请选择请选择省/市/区（县）" },
        ],
        registAddress: [{ required: true, message: "请输入注册地（地址）" }],
        hasLessorStateOwned: [
          { required: true, message: "请选择出租方是否国资" },
        ],
        economicTypeLessor: [
          { required: true, message: "请选择出租方经济类型" },
        ],
        groupDepartment: [{ required: true, message: "请选择所属集团" }],
        regulatoryAuthorities: [{ required: true, message: "请选择监管部门" }],
        email: [{ required: true, message: "请输入电子邮件" }],
        mailingAddress: [{ required: true, message: "请输入通讯地址" }],
        personCertType: [{ required: true, message: "请选择自然人证件类型" }],
        personCertNumber: [{ required: true, message: "请输入出租方证件号码" }],
      },
    };
  },

  mounted() {
    //1.详情查询出所有的历史数据+所有树结构
    //判断是否有webId,有需要调用，form.otpye = 1改为修改 form.webId = webId，最好加个loading
    if (this.webId && this.webId.trim() !== "") {
      this.spinning = true;
      getIntentDetail({ webId: this.webId })
        .then((res) => {
          if (res && res.code === "200") {
            const baseInfo = res.data.baseInfo;
            this.form.otype = 1;
            //  全量覆盖（包括 null）
            Object.keys(baseInfo).forEach((key) => {
              this.form[key] = baseInfo[key];
            });

            // 特殊字段处理
            this.form.provinceCityRegion = [
              baseInfo.registerProvince,
              baseInfo.registerCity,
              baseInfo.registerRegion,
            ].filter(Boolean);

            // 数组兜底（防止组件报错）
            this.form.engineeringConditions =
              baseInfo.engineeringConditions || [];
            this.form.leaseType = baseInfo.leaseType || [];
            this.form.businessCategories = baseInfo.businessCategories || [];
            this.form.parkCategories = baseInfo.parkCategories || [];
            this.form.intentionLeaseRange = baseInfo.intentionLeaseRange || [];
            this.form.supportingServices = baseInfo.supportingServices || [];

            // 所属集团
            this.form.groupDepartment = {
              label: baseInfo.groupDepartment,
              value: baseInfo.groupDepartmentCode,
            };
            // 监管部门
            this.form.regulatoryAuthorities = {
              label: baseInfo.regulatoryAuthorities,
              value: baseInfo.regulatoryAuthoritiesCode,
            };

            //注册地址映射
            this.registerAddressString = baseInfo.registerAddressString

            //其他公示的附件
            this.form.publicAttachment.find(
              (item) => item.uploadType === 301
            ).files = res.data.publicAttachment.map((item) => {
              return {
                uid: uuidv4(),
                name: item.fileName,
                status: "done",
                url: item.publicAttachmentUrl,
              };
            });
            // 材料补充清单
            this.form.supplyCheckList = (res.data.supplyCheckList || []).map(
              (item) => {
                return {
                  ...item,
                  attachments: (item.attachments || []).map((file) => ({
                    uid: uuidv4(),
                    name: file.fileName,
                    status: "done",
                    url: file.supplyCheckFileUrl,
                  })),
                };
              }
            );
          } else {
            this.$notification.error({
              message: "跳转详情页失败",
              description: res.msg,
            });

            this.$emit("back");

            this.$nextTick(() => {
              scrollToTop(this, 80);
            });
          }
        })
        .catch((err) => {
          console.error("接口调用异常：", err);
        })
        .finally(() => {
          //缓冲转圈
          this.spinning = false;
        });
    }
  },

  watch: {
    //基础数据中的stateOwned和出租人信息中的hasLessorStateOwned保持一致
    "form.hasLessorStateOwned"(val) {
      this.form.stateOwned = val === undefined ? 0 : val;
    },
    //基础数据中的stateOwned和出租人信息中的hasLessorStateOwned保持一致
    "form.lessorType"(val) {
      if (val != 1) {
        this.form.hasLessorStateOwned = 0;
      }
    },
    //公告时间
    "form.disclosurePeriodExtend"(val) {
      this.$nextTick(() => {
        if (val === 12) {
          this.$refs.baseForm.validateField([
            "extendWorkingDays",
            "extendedCyclesNumber",
          ]);
        } else {
          this.$refs.baseForm.clearValidate([
            "extendWorkingDays",
            "extendedCyclesNumber",
          ]);
        }
      });
    },
    //租赁期限区间
    "form.leaseTermType"(val) {
      this.$nextTick(() => {
        // 1. 清除校验状态
        this.$refs.baseForm.clearValidate([
          "leaseTerm",
          "leaseTermMin",
          "leaseTermMax",
          "leaseTermUnit",
        ]);
      });
    },
    //出租参考价区间
    "form.listingPriceType"(val) {
      // 清校验状态
      this.$nextTick(() => {
        this.$refs.baseForm.clearValidate([
          "listingPrice",
          "listingPriceDown",
          "listingPriceUp",
          "listingPriceUnit",
        ]);
      });
    },
    //免租期区间
    "form.hasRentFreePeriodType"(val) {
      this.$nextTick(() => {
        this.$refs.baseForm.clearValidate([
          "rentFreePeriod",
          "rentFreePeriodMin",
          "rentFreePeriodMax",
          "rentFreePeriodUnit",
        ]);
      });
    },
    "form.rentPaymenclaim"(val) {
      if (val === 1) {
        this.form.rentPaymenclaimOtherDesc = undefined;
      } else {
        this.form.rentPaymenclaimDeposit = undefined;
        this.form.rentPaymenclaimPay = undefined;
      }

      this.$nextTick(() => {
        this.$refs.baseForm.clearValidate([
          "rentPaymenclaimDeposit",
          "rentPaymenclaimPay",
          "rentPaymenclaimOtherDesc",
        ]);
      });
    },
    // 受委托进行招租活动
    "form.hasEntrustRent": {
      immediate: true,
      handler(val) {
        // todo开始
        // ⭐核心判断加入页面模式mode,如果是详情则跳过，直接用调用数据
        // if (this.mode === "view") return;
        // todo结束
        //不授权登记
        if (val === 0) {
          // 清除校验错误
          this.$nextTick(() => {
            this.$refs.baseForm?.clearValidate([
              "lessorName",
              "lessorType",
              "businessPrincipal",
              "principalContactNumber",
              "certType",
              "certNumber",
              "legalPerson",
              "registAddress",
              "hasLessorStateOwned",
              "economicTypeLessor",
              "groupDepartment",
              "regulatoryAuthorities",
              "email",
              "mailingAddress",
              "personCertType",
              "personCertNumber",
              "country",
              "provinceCityRegion",
            ]);
          });
          //变更为默认权利人信息
          this.form.lessorType = 1;
          this.form.certType = 19;
          getObligeeDetail()
            .then((res) => {
              if (res && res.code === "200") {
                const result = res.data;
                this.form.lessorName = result.obligeeName;
                this.form.legalPerson = result.legalRepresentative;
                this.form.certNumber = result.socialCreditCode;
                this.form.hasLessorStateOwned =
                  result.obligeeStateOwnedEnterprises;
                this.form.economicTypeLessor = result.obligeeEconomicType;
                this.form.groupDepartment = {
                  label: result.obligeeAffiliatedGroup,
                  value: result.obligeeAffiliatedGroupCreditCode,
                };
                this.form.regulatoryAuthorities = {
                  label: result.obligeeRegulatoryAuthority,
                  value: result.obligeeRegulatoryAuthorityCreditCode,
                };
              } else {
              }
            })
            .catch((err) => {
              console.error("接口调用异常：", err);
            });
        } else {
        }
      },
    },
  },

  methods: {
    /** 保存（不强校验） */
    async handleSave() {
      try {
        // 将注册地址映射成
        const provinceCityRegion = this.form.provinceCityRegion || [];
        this.form.registerProvince = provinceCityRegion[0] || undefined;
        this.form.registerCity = provinceCityRegion[1] || undefined;
        this.form.registerRegion = provinceCityRegion[2] || undefined;

        const coverPhoto = this.form.coverPhoto
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        const projectPhoto = this.form.projectPhoto
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        // 公示附件（301）
        const publicAttachment = this.form.publicAttachment
          .filter((item) => item.uploadType === 301)
          .flatMap((item) => item.files || [])
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        const res = await saveIntentLease({
          ...this.form,
          //房源封面
          coverPhoto,
          //房源图片
          projectPhoto,
          //附件文件
          publicAttachment,
          //树结构重构下参数
          groupDepartment: this.form.groupDepartment?.label || "",
          groupDepartmentCode: this.form.groupDepartment?.value || "",
          regulatoryAuthorities: this.form.regulatoryAuthorities?.label || "",
          regulatoryAuthoritiesCode:
            this.form.regulatoryAuthorities?.value || "",
        });

        if (res && res.code === "200") {
          const result = res.data;
          this.form.otype = 1;
          this.form.webId = result;

          // 延迟 500ms，让页面看起来顺滑一点，避免闪屏
          await new Promise((resolve) => setTimeout(resolve, 500));

          this.$notification.success({
            message: `保存成功`,
            description: `意向发布项目登记`,
          });

          return true;
        } else {
          this.$notification.error({
            message: "保存失败",
            description: err?.message,
          });

          return false;
        }
      } catch (err) {
        console.error("接口调用异常：", err);

        this.$notification.error({
          message: "保存失败",
          description: "接口调用异常",
        });
        throw err;
      }
    },

    /** 提交（强校验） */
    async handleSubmit() {
      try {
        // 表单校验（Promise化）
        const { valid, firstErrorMsg } = await new Promise((resolve) => {
          this.$refs.baseForm.validate((valid, errors) => {
            if (valid) {
              resolve({
                valid: true,
                firstErrorMsg: "",
              });
              return;
            }

            // 从 errors 里随便取一个错误
            let msg = "请先完善进场公开招租申请信息";

            if (errors) {
              for (const key in errors) {
                if (errors[key] && errors[key].length > 0) {
                  msg = errors[key][0].message;
                  break; // 取第一个就行
                }
              }
            }

            resolve({
              valid: false,
              firstErrorMsg: msg,
            });
          });
        });

        if (!valid) {
          this.$notification.warning({
            message: "注意",
            description: firstErrorMsg,
            duration: 4,
          });

          return false;
        }

        // 将注册地址映射成
        const provinceCityRegion = this.form.provinceCityRegion || [];
        this.form.registerProvince = provinceCityRegion[0] || undefined;
        this.form.registerCity = provinceCityRegion[1] || undefined;
        this.form.registerRegion = provinceCityRegion[2] || undefined;

        const coverPhoto = this.form.coverPhoto
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        const projectPhoto = this.form.projectPhoto
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        // 公示附件（301）
        const publicAttachment = this.form.publicAttachment
          .filter((item) => item.uploadType === 301)
          .flatMap((item) => item.files || [])
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        const res = await submitIntentLease({
          ...this.form,
          //房源封面
          coverPhoto,
          //房源图片
          projectPhoto,
          //附件文件
          publicAttachment,
          //树结构重构下参数
          groupDepartment: this.form.groupDepartment?.label || "",
          groupDepartmentCode: this.form.groupDepartment?.value || "",
          regulatoryAuthorities: this.form.regulatoryAuthorities?.label || "",
          regulatoryAuthoritiesCode:
            this.form.regulatoryAuthorities?.value || "",
        });
        await new Promise((resolve) => setTimeout(resolve, 300));
        if (!res || res.code !== "200") {
          this.$notification.warning({
            message: `提交失败`,
            description: res.msg,
          });
          return false;
        }

        this.$notification.success({
          message: "提交成功",
          description: "请等待审核结果",
        });

        this.$emit("back");

        this.$nextTick(() => {
          scrollToTop(this, 80);
        });

        return true;
      } catch (err) {
        console.error("接口调用异常：", err);

        this.$notification.warning({
          message: "提交失败",
          description: err?.message || "接口异常",
        });
        throw err;
      }
    },
  },
};
</script>

<style scoped>
.detail-collapse {
  background: #fff;
}
.detail-collapse /deep/ .ant-collapse-header {
  font-size: 15px;
  font-weight: bold;
}
.detail-collapse /deep/ input.ant-input {
  height: 32px !important;
  border-radius: 4px;
}

.detail-collapse /deep/ checkbox.ant-checkbox {
  height: 32px !important;
  border-radius: 4px;
}

::v-deep .detail-collapse .ant-form-item {
  margin-bottom: 8px !important;
}

.title_icon {
  width: 6px;
  height: 22px;
  background: #007aff;
}
</style>
